import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function CDPCertificate() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');
  const [collegeName, setCollegeName] = useState('');
  const [generating, setGenerating] = useState(false);
  const [err, setErr] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data: d } = await api.get('/cdp/certificate');
        setData(d);
      } catch { }
      finally { setLoading(false); }
    })();
  }, []);

  const handleGenerate = async () => {
    if (!userName.trim()) return setErr('Please enter your full name.');
    if (!collegeName.trim()) return setErr('Please enter your college/institution name.');
    setErr(''); setGenerating(true);
    try {
      const { data: d } = await api.post('/cdp/certificate', { userName: userName.trim(), collegeName: collegeName.trim() });
      setData(prev => ({ ...prev, certificate: d.certificate }));
    } catch (e) { setErr(e.response?.data?.error || 'Failed to generate certificate'); }
    finally { setGenerating(false); }
  };

  if (loading) return <div style={s.center}><div style={s.spin} /></div>;
  if (!data?.eligible) return (
    <div style={s.page} className="page-content">
      <button onClick={() => navigate('/cdp')} style={s.back}>← Back to Programme</button>
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <h2 style={s.h2}>Not Yet Eligible</h2>
        <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: '1.6' }}>
          Pass at least 4 documents to earn your Certificate of Completion.<br />
          You have passed {data?.passedCount || 0} out of {data?.totalDocs || 7}.
        </p>
        <button onClick={() => navigate('/cdp')} style={s.btn}>Continue Drafting</button>
      </div>
    </div>
  );

  const cert = data.certificate;

  // No certificate yet — ask for details
  if (!cert) return (
    <div style={s.page} className="page-content">
      <button onClick={() => navigate('/cdp')} style={s.back}>← Back to Programme</button>
      <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '32px 28px', marginTop: '16px', maxWidth: '480px', marginLeft: 'auto', marginRight: 'auto' }}>
        <h2 style={{ ...s.h2, textAlign: 'center', marginBottom: '4px' }}>Congratulations!</h2>
        <p style={{ fontSize: '13px', color: '#6b7280', textAlign: 'center', lineHeight: '1.6', marginBottom: '20px' }}>
          You are eligible for your certificate. Please confirm the details below — these will appear on your certificate exactly as entered.
        </p>

        <div style={{ marginBottom: '14px' }}>
          <label style={s.label}>Full Name (as it should appear on the certificate)</label>
          <input value={userName} onChange={e => setUserName(e.target.value)} placeholder="e.g. Rahul Sharma" style={s.input} />
        </div>

        <div style={{ marginBottom: '14px' }}>
          <label style={s.label}>College / Institution Name</label>
          <input value={collegeName} onChange={e => setCollegeName(e.target.value)} placeholder="e.g. Government Law College, Mumbai" style={s.input} />
        </div>

        {err && <p style={{ fontSize: '13px', color: '#991b1b', background: '#fef2f2', padding: '8px 12px', borderRadius: '8px', marginBottom: '10px' }}>{err}</p>}

        <button onClick={handleGenerate} disabled={generating} style={{ ...s.btn, width: '100%', opacity: generating ? 0.5 : 1 }}>
          {generating ? 'Generating...' : 'Generate My Certificate'}
        </button>

        <p style={{ fontSize: '11px', color: '#9ca3af', textAlign: 'center', marginTop: '10px', lineHeight: '1.5' }}>
          Certificate level: <strong>{data.level === 'gold' ? 'Gold' : data.level === 'silver' ? 'Silver' : 'Completion'}</strong> ({data.passedCount} of {data.totalDocs} documents passed)
        </p>
      </div>
    </div>
  );

  // Certificate exists — display it
  const levelLabel = cert.level === 'gold' ? 'GOLD CERTIFICATE' : cert.level === 'silver' ? 'SILVER CERTIFICATE' : 'CERTIFICATE OF COMPLETION';
  const isGold = cert.level === 'gold';
  const borderColor = isGold ? '#b45309' : cert.level === 'silver' ? '#6b7280' : '#0c2340';

  return (
    <div style={s.page} className="page-content">
      <button onClick={() => navigate('/cdp')} style={s.back}>← Back to Programme</button>

      <div style={{ ...s.certCard, borderColor }}>
        <p style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '2.5px', textTransform: 'uppercase', color: '#6b7280', marginBottom: '4px' }}>
          COMMERCIAL DRAFTING — CERTIFIED PRACTICE SESSION
        </p>
        <p style={{ fontSize: '12px', fontStyle: 'italic', color: '#6b7280', marginBottom: '16px' }}>by AskNitin.com</p>

        {cert.level !== 'completion' && (
          <p style={{ fontSize: '14px', fontWeight: '800', color: borderColor, letterSpacing: '3px', marginBottom: '16px' }}>{levelLabel}</p>
        )}

        <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '6px' }}>This is to certify that</p>
        <h1 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: '28px', fontWeight: '700', color: '#0c2340', margin: '0 0 4px' }}>
          {cert.userName}
        </h1>
        {cert.collegeName && (
          <p style={{ fontSize: '13px', color: '#6b7280', fontStyle: 'italic', marginBottom: '16px' }}>{cert.collegeName}</p>
        )}

        <p style={{ fontSize: '13px', color: '#374151', lineHeight: '1.7', maxWidth: '500px', margin: '0 auto 16px' }}>
          has successfully completed {isGold ? <strong>all seven documents</strong> : cert.level === 'silver' ? <strong>six out of seven documents</strong> : <strong>four documents</strong>} in the <strong>Commercial Drafting — Certified Practice Session</strong> conducted under the mentorship of <strong>Nitin Potdar, Senior Corporate Lawyer, Mumbai.</strong>
        </p>

        <p style={{ fontSize: '12px', fontWeight: '600', color: '#0c2340', marginBottom: '6px' }}>Documents completed:</p>
        <ol style={{ textAlign: 'left', maxWidth: '400px', margin: '0 auto 16px', paddingLeft: '20px' }}>
          {cert.documentTitles?.map((t, i) => (
            <li key={i} style={{ fontSize: '13px', color: '#374151', marginBottom: '3px' }}>{t}</li>
          ))}
        </ol>

        {isGold && (
          <p style={{ fontSize: '12px', fontStyle: 'italic', color: '#374151', lineHeight: '1.7', maxWidth: '460px', margin: '0 auto 16px', background: '#fffbeb', padding: '12px 16px', borderRadius: '8px' }}>
            "This student has completed all seven documents in the Commercial Drafting Certified Practice Session — demonstrating commitment, diligence and a genuine investment in the craft of commercial legal drafting."
          </p>
        )}

        <p style={{ fontSize: '12px', fontStyle: 'italic', color: '#6b7280', marginBottom: '16px' }}>
          This certificate recognises active participation in a practical legal drafting programme. It does not represent a formal legal qualification.
        </p>

        <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '14px', fontSize: '12px', color: '#6b7280' }}>
          <p style={{ margin: '0 0 3px' }}><strong>Certificate No.:</strong> {cert.certificateNumber}</p>
          <p style={{ margin: '0 0 12px' }}><strong>Date of Completion:</strong> {new Date(cert.issuedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
          <p style={{ fontWeight: '700', color: '#0c2340', margin: '0 0 2px', fontSize: '13px' }}>Nitin Potdar</p>
          <p style={{ margin: 0, lineHeight: '1.5' }}>Senior Corporate Lawyer | Author | Mentor<br />AskNitin.com | Mumbai</p>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '16px' }}>
        <p style={{ fontSize: '12px', color: '#6b7280' }}>
          Verify this certificate: <strong>{cert.certificateNumber}</strong>
        </p>
      </div>
    </div>
  );
}

const s = {
  page: { maxWidth: '700px', margin: '0 auto', padding: '28px 20px 60px' },
  center: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 60px)' },
  spin: { width: '28px', height: '28px', borderRadius: '50%', border: '2.5px solid #e5e7eb', borderTop: '2.5px solid #0c2340', animation: 'spin 0.8s linear infinite' },
  back: { background: 'none', border: 'none', color: '#0c2340', fontSize: '13px', fontWeight: '600', cursor: 'pointer', padding: 0, marginBottom: '16px', display: 'block' },
  h2: { fontFamily: "'DM Sans',sans-serif", fontSize: '22px', fontWeight: '800', color: '#0c2340', marginBottom: '8px' },
  btn: { background: '#0c2340', color: '#fff', border: 'none', padding: '11px 22px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: "'DM Sans',sans-serif" },
  label: { fontSize: '12px', fontWeight: '700', color: '#0c2340', display: 'block', marginBottom: '4px' },
  input: { width: '100%', padding: '10px 14px', borderRadius: '10px', border: '1.5px solid #d1d5db', fontSize: '14px', fontFamily: "'DM Sans',sans-serif", outline: 'none', boxSizing: 'border-box' },
  certCard: {
    background: '#fff', border: '2px solid #0c2340', borderRadius: '16px', padding: '36px 28px',
    textAlign: 'center', marginTop: '16px',
    boxShadow: '0 4px 20px rgba(12,35,64,0.08)',
  },
};
